import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";
import {
  FAQS,
  TERMS_AND_CONDITION,
  REGISTER_TERMS_AND_CONDITION,
} from "./helper";
import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import backgroundImage from "public/images/lovb_nebraska/lovb_nebraska_background.jpg";

const logo =
  "https://ss-leagues.s3.amazonaws.com/LOVB/Nebraska/lovb-nebraska-logo.png";

export const lovb_nebraska: TTeamConfig = {
  TEAM_SCHEMA: "lovb_nebraska",
  TEAM_FULL_NAME: "League One Volleyball",
  BROWSER_TITLE: "LOVB Nebraska Pass",
  CLIENT_ID: "b8ffca07a261.seasonshare.lovb-lovb.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#7af5b3",
    COLORS_SECONDARY: "#ccfbe2",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    FOOTER: {
      BACKGROUND_COLOR: "#7af5b3",
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
      SHOW_FAQ_BUTTON: true,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTER_TERMS_AND_CONDITION />,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },

    ADD_DARK_OVERLAY: true,
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: logo,
    ORDER_SUMMERY_BACKGROUND_URL: backgroundImage.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
  },
};
